import React from "react";

import ReactMarkdown from "react-markdown";
import MarkdownHelper from '../../../utils/MarkdownHelper';

import { default as t } from '../../../utils/Translate';

const AppQuizFirst = props => (
    <div className="app-type app-spacers">
        <div className="app-view mb-md">
            <div className="quiz-container">
                <div className="app-quiz-container">
                    <img src={props.quiz.image32streamtilequiz} className="app-quiz-background" />
                </div>
            </div>
        </div>
    </div>
)

const AppQuizFollowUp = props => (
    <div className="app-type app-spacers">
        <div className="app-view mb-md">
            <div className="quiz-container quiz-conatiner-page">
                <div className="app-quiz-container">
                    <img src={props.quiz.image32detailviewquiz} className="app-quiz-background" />
                </div>
                <div className="app-quiz-followup-conent-container">
                    <div className="app-quiz-followup-conent-frage">{props.quiz['frage-follow-up']}</div>
                    <div className="app-quiz-followup-conent-frage-text">{props.quiz['detail-view-copy-long-follow-up']}</div>
                </div>
            </div>
        </div>
    </div>
)

const AppQuizTermsAndConditions = props => (
    <div className="app-type app-spacers">
        <div className="app-view mb-md">
            <div className="quiz-container quiz-conatiner-page">
                <div className="appquiz-terms-conditions__title">
                    {t('Terms and Conditions', props.lang)}
                </div>
                <div className="appquiz-terms-conditions__content-container">
                    <div className="appquiz-terms-conditions__content">
                        <div className="appquiz-terms-conditions__content--headline">{props.quiz['terms-conditions-headline']}</div>
                        <ReactMarkdown {...MarkdownHelper.allTypes()}
                            source={t(MarkdownHelper.parse(props.quiz['terms-conditions'] || appQuizDefaultState['terms-conditions']), props.lang)}
                            escapeHtml={false} />
                    </div>
                    <button className="btn btn--mobile">
                        Apply
                    </button>
                </div>
            </div>
        </div>
    </div>
)

const AppQuizQuestionScreen = props => (
    <div className="app-type app-spacers">
        <div className="app-view mb-md">
            <div className="quiz-container quiz-conatiner-page">
                <div className="appquiz-question-header">
                    <div className="cancel">Cancel</div>
                    <div className="appquiz-logo">
                        <img src={props.partnerLogo} alt="Partner logo" />
                    </div>
                    <div className="question-number">1/1</div>
                </div>
                <div className="appquiz-question">
                    <div className="question-box">{props.quiz['frage-quiz']}</div>

                </div>
                <img src={props.quiz['image32-topoffere-mailbasicoffere-mailappteaser-appstre']} alt="Question Image" className="question-image" />
                <div className="appquiz-options">
                    <div className="appquiz-answer-option">
                        {props.quiz['antwort-1-quiz']}
                    </div>
                    <div className="appquiz-answer-option">
                        {props.quiz['antwort-2-quiz']}
                    </div>
                    <div className="appquiz-answer-option">
                        {props.quiz['antwort-3-quiz']}
                    </div>
                    <div className="appquiz-answer-option">
                        {props.quiz['antwort-4-quiz']}
                    </div>
                </div>
            </div>
        </div>
    </div>
)

const AppQuizAnswerScreen = props => {


    const isCorrectAnswer = (option) => {
        return (option == props.quiz['antwort-feedback'])

    }
    return (
        <div className="app-type app-spacers">
            <div className="app-view mb-md">
                <div className="quiz-container quiz-conatiner-page">
                    <div className="appquiz-question-header">
                        <div className="cancel">Cancel</div>
                        <div className="appquiz-logo">
                            <img src={props.partnerLogo} alt="Partner logo" />
                        </div>
                        <div className="question-number">1/1</div>
                    </div>
                    <div className="appquiz-question">
                        <div className="question-box"> {props.quiz['frage-quiz']}</div>
                    </div>
                    <img src={props.quiz['image32-topoffere-mailbasicoffere-mailappteaser-appstre']} alt="Question Image" className="question-image" />
                    <div className="appquiz-options">
                        <div className={`appquiz-answer-option ${isCorrectAnswer(props.quiz['antwort-1-quiz']) ? 'correct-answer' : 'disabled'}`}>
                            {props.quiz['antwort-1-quiz']}
                        </div>
                        <div className={`appquiz-answer-option ${isCorrectAnswer(props.quiz['antwort-2-quiz']) ? 'correct-answer' : 'disabled'}`}>
                            {props.quiz['antwort-2-quiz']}
                        </div>
                        <div className={`appquiz-answer-option ${isCorrectAnswer(props.quiz['antwort-3-quiz']) ? 'correct-answer' : 'disabled'}`}>
                            {props.quiz['antwort-3-quiz']}
                        </div>
                        <div className={`appquiz-answer-option ${isCorrectAnswer(props.quiz['antwort-4-quiz']) ? 'correct-answer' : 'disabled'}`}>
                            {props.quiz['antwort-4-quiz']}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const AppQuiz = props => (
    <div className="appquiz-app">
        <AppQuizFirst {...props} />
        <hr />
        <AppQuizFollowUp {...props} />
        <hr />
        <AppQuizTermsAndConditions {...props} />
        <hr />
        <AppQuizQuestionScreen {...props} />
        <hr />
        <AppQuizAnswerScreen {...props} />
    </div>
)

const appQuizDefaultState = {
    'terms-conditions': ''
}

export default AppQuiz;



// WEBPACK FOOTER //
// ./src/components/ads/app/AppQuiz/AppQuiz.js